import { useEffect, useState } from 'react'
import { Button } from '@/common/ui/button'
import { Modal } from '@/common/ui/modal'
import { AlertTriangle } from 'lucide-react'

interface ProbabilityWarningDialogProps {
	isOpen: boolean
	onClose: () => void
	totalProbability: number
}

export const ProbabilityWarningDialog: React.FC<
	ProbabilityWarningDialogProps
> = ({ isOpen, onClose, totalProbability }) => {
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)
	}, [])

	if (!isMounted) {
		return null
	}

	return (
		<Modal
			title="⚠️ การส่งข้อมูลล้มเหลว"
			description="ไม่สามารถบันทึกข้อมูลได้เนื่องจากเปอร์เซ็นต์การออกรางวัลเกิน 100%"
			isOpen={isOpen}
			onClose={onClose}
		>
			<div className="space-y-4">
				<div className="flex items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-800 dark:border-red-800 dark:bg-red-950/20 dark:text-red-200">
					<AlertTriangle className="h-6 w-6 flex-shrink-0 text-red-600 dark:text-red-400" />
					<div className="text-sm">
						<p className="font-bold text-red-900 dark:text-red-100">
							❌ การส่งข้อมูลถูกยกเลิก
						</p>
						<p className="mt-1 font-semibold text-red-800 dark:text-red-200">
							เปอร์เซ็นต์รวมปัจจุบัน: {totalProbability.toFixed(1)}%
						</p>
						<p className="mt-2 leading-relaxed">
							<span className="font-medium">เหตุผล:</span>{' '}
							เปอร์เซ็นต์การออกรางวัลรวมเกิน 100%
							<br />
							<span className="font-medium">วิธีแก้ไข:</span>{' '}
							กรุณาปรับแต่งเปอร์เซ็นต์ในแต่ละรางวัลให้มีค่ารวมไม่เกิน 100%
							แล้วลองบันทึกใหม่อีกครั้ง
						</p>
					</div>
				</div>
				<div className="flex w-full items-center justify-end space-x-2 pt-2">
					<Button
						variant="outline"
						onClick={onClose}
						className="border-red-300 text-red-700 hover:bg-red-50 dark:border-red-600 dark:text-red-300 dark:hover:bg-red-950/30"
					>
						ปิด
					</Button>
				</div>
			</div>
		</Modal>
	)
}
